import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};

// `getRouter` is a factory (fresh instance per call, e.g. per test) rather than a module-level
// singleton, so there is no single `router` value to reference here. Its return type is the same
// on every call, though, so it stands in for the singleton TanStack's docs normally register.
export type AppRouter = ReturnType<typeof getRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
}
